import logoImg from "../batens_verden/images/sjoenforalle-logo3.png";
import c from "./lesSjoenForAlleMagasin.module.scss";
import {Link} from "react-router-dom";
import ArrowRightIcon from "../svg/ArrowRightIcon";

export default function LesSjoenForAlleMagasin(){
	return <Link to={'/sjoen-for-alle'} className={c.root}>
		<img src={logoImg}/>
		<div></div>
		<Link to={'/sjoen-for-alle'}>Les Messemagasinet <ArrowRightIcon width={'0.7em'} height={'0.7em'}/></Link>
	</Link>
}